import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-driveb-simple-card-status",
  templateUrl: "./simple-card-status.component.html",
  styleUrl: "./simple-card-status.component.scss",
  standalone: false
})
export class SimpleCardStatusComponent implements OnInit {
  @Input() title = "";
  @Input() link = "";
  @Input() param = "";
  @Input() quantity = 0;
  @Input() tooltip?: string;

  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit(): void {}

  handleClick(): void {
    if (this.link && this.param) {
      this.router.navigate([this.link], {
        queryParams: { status: this.param },
        relativeTo: this.route
      });
    }
  }
}
